/**
 * @generated SignedSource<<bf6797bcc455e5b9b21455cbbfbfb54c>>
 * @relayHash c2b98978082788d4d50aace3a2030149
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 480e364865776dcd2811bc8565bcdbccd9b13a24e85ea6c62e923fb2209d69bf

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraVersionDetailsCollapsedUi = "DESCRIPTION" | "ISSUES" | "ISSUE_ASSOCIATED_DESIGNS" | "PROGRESS_CARD" | "RELATED_WORK" | "RICH_TEXT_SECTION" | "RIGHT_SIDEBAR" | "%future added value";
export type JiraVersionDetailsCollapsedUisInput = {
  collapsedUis: ReadonlyArray<JiraVersionDetailsCollapsedUi>;
  versionId: string;
};
export type rightSidebar_softwareReleasesVersionDetail_updateCollapsedUisMutation$variables = {
  input: JiraVersionDetailsCollapsedUisInput;
};
export type rightSidebar_softwareReleasesVersionDetail_updateCollapsedUisMutation$data = {
  readonly jira: {
    readonly saveVersionDetailsCollapsedUis: {
      readonly success: boolean;
      readonly version: {
        readonly collapsedUis: ReadonlyArray<JiraVersionDetailsCollapsedUi | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type rightSidebar_softwareReleasesVersionDetail_updateCollapsedUisMutation$rawResponse = {
  readonly jira: {
    readonly saveVersionDetailsCollapsedUis: {
      readonly success: boolean;
      readonly version: {
        readonly collapsedUis: ReadonlyArray<JiraVersionDetailsCollapsedUi | null | undefined> | null | undefined;
        readonly id: string;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type rightSidebar_softwareReleasesVersionDetail_updateCollapsedUisMutation = {
  rawResponse: rightSidebar_softwareReleasesVersionDetail_updateCollapsedUisMutation$rawResponse;
  response: rightSidebar_softwareReleasesVersionDetail_updateCollapsedUisMutation$data;
  variables: rightSidebar_softwareReleasesVersionDetail_updateCollapsedUisMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "collapsedUis"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "rightSidebar_softwareReleasesVersionDetail_updateCollapsedUisMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraVersionDetailsCollapsedUisPayload",
            "kind": "LinkedField",
            "name": "saveVersionDetailsCollapsedUis",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "JiraVersion",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "rightSidebar_softwareReleasesVersionDetail_updateCollapsedUisMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraVersionDetailsCollapsedUisPayload",
            "kind": "LinkedField",
            "name": "saveVersionDetailsCollapsedUis",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "JiraVersion",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "480e364865776dcd2811bc8565bcdbccd9b13a24e85ea6c62e923fb2209d69bf",
    "metadata": {},
    "name": "rightSidebar_softwareReleasesVersionDetail_updateCollapsedUisMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "eae188b16f12cd7a08081363e9d8ba79";

export default node;
